import React from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

import { API } from "config";

/**
 * Returns a function that acquires an access token for the metrics API.
 * Follows the same pattern as `useGetAccessToken` but with a fixed scope
 * for the corteva-chat-metrics App Registration.
 */
export default function useGetMetricsToken() {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || null);
  const scope = API.metricsApi.scope;

  const getAccessToken = React.useCallback(async () => {
    if (!scope) {
      throw new Error("Metrics API scope is not configured");
    }
    if (account) {
      const request = {
        scopes: [scope],
        account: account,
      };

      try {
        const response = await instance.acquireTokenSilent(request);
        return response.accessToken;
      } catch (e) {
        if (e instanceof InteractionRequiredAuthError) {
          const response = await instance.acquireTokenPopup(request);
          return response.accessToken;
        }
        throw e;
      }
    }
    throw new Error("No accounts found");
  }, [instance, account, scope]);

  return getAccessToken;
}
